import { api } from '@/lib/axios';

export interface EmailTemplate {
  id: string;
  name: string;
  subject: string;
  body: string;
  category?: string;
  variables?: string;
  description?: string;
  active: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateEmailTemplateDto {
  name: string;
  subject: string;
  body: string;
  category?: string;
  variables?: string;
  description?: string;
  active?: boolean;
}

export interface UpdateEmailTemplateDto {
  name?: string;
  subject?: string;
  body?: string;
  category?: string;
  variables?: string;
  description?: string;
  active?: boolean;
}

export interface EmailTemplatesQueryDto {
  search?: string;
  category?: string;
  activeOnly?: boolean;
  page?: number;
  pageSize?: number;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}

export interface PaginatedResponse<T> {
  data: T[];
  total: number;
  page: number;
  pageSize: number;
  totalPages: number;
}

export const emailTemplatesService = {
  async getAll(params: EmailTemplatesQueryDto): Promise<PaginatedResponse<EmailTemplate>> {
    const response = await api.get<PaginatedResponse<EmailTemplate>>('/email-templates', { params });
    return response.data;
  },

  async getById(id: string): Promise<EmailTemplate> {
    const response = await api.get<EmailTemplate>(`/email-templates/${id}`);
    return response.data;
  },

  async getByCategory(category: string): Promise<EmailTemplate[]> {
    const response = await api.get<EmailTemplate[]>(`/email-templates/category/${category}`);
    return response.data;
  },

  async create(data: CreateEmailTemplateDto): Promise<EmailTemplate> {
    const response = await api.post<EmailTemplate>('/email-templates', data);
    return response.data;
  },

  async update(id: string, data: UpdateEmailTemplateDto): Promise<EmailTemplate> {
    const response = await api.put<EmailTemplate>(`/email-templates/${id}`, data);
    return response.data;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/email-templates/${id}`);
  },

  async toggle(id: string): Promise<EmailTemplate> {
    const response = await api.post<EmailTemplate>(`/email-templates/${id}/toggle`);
    return response.data;
  },

  async duplicate(id: string): Promise<EmailTemplate> {
    const response = await api.post<EmailTemplate>(`/email-templates/${id}/duplicate`);
    return response.data;
  },
};
